import type { Agent } from '../../types';

/** The `category` the drawer's "Open Moo Studio" row passes to the host's
 *  `renderAgentAvatar`, so the host can draw Studio's mark distinctly from
 *  the agents listed under it. */
export const STUDIO_AVATAR_CATEGORY = 'studio';

/** The category as a type, so a host can match it without importing this
 *  library's runtime (`const c: StudioAvatarCategory = 'studio'` fails to
 *  type-check if the value ever changes). */
export type StudioAvatarCategory = typeof STUDIO_AVATAR_CATEGORY;

/** What the Studio row hands `renderAgentAvatar`: not an agent, but shaped
 *  like one so the host renders it through the same slot. */
export const STUDIO_AVATAR_AGENT: Agent = {
  id: 'moo-studio',
  name: 'Moo Studio',
  category: STUDIO_AVATAR_CATEGORY,
};
